import Vue from "vue";
import App from "@/App.vue";
// import router from "@/router";
import router from '@/router'
import VeeValidate, { validate } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja';
import validation from './validations'
import VueCompositionApi from "@vue/composition-api";
import Filters from "@/lib/filters";
import Vuelidate from "vuelidate";
import vuetify from '@/plugins/vuetify';
// import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false;
Vue.use(VueCompositionApi, Vuelidate);

// Vue.use(vuetify, {
//   iconfont: 'mdi',
//   theme: {
//     // primary: '#231815',
//     primary: '#363829',
//     secondary: '#ffda01',
//     white: '#ffffff',
//     error: '#e60012',
//     blue: '#2d72c3',
//     red: '#c32d2d',
//     icon: '#363829'
//   },
//   icons: {
//     'search': 'mdi-magnify',
//     'check': 'mdi-check',
//     'delete': 'mdi-trash-can-outline',
//     'right': 'mdi-chevron-right',
//     'tilde': 'mdi-tilde',
//     'minus': 'mdi-minus',
//     'at': 'mdi-at',
//     'menu': 'mdi-menu',
//     'check-underline': 'mdi-check-underline'
//   }
// });
Vue.mixin({
  filters: Filters
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");

